export const appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#444',
    colorBackground: '#f7f4f1',
    colorText: '#000',
    colorDanger: '#df1b41',
    fontFamily: '"Apercu Pro", "Helvetica", sans-serif',
    spacingUnit: '4px',
    borderRadius: '0',
    colorSuccess: 'green',
    spacingAccordionItem: '500px'
  },
  rules: {
    '.AccordionItem': {
      backgroundColor: 'transparent',
      border: '1px solid transparent',
      boxShadow: 'none',
    },
    '.Input': {
      backgroundColor: '#F7F7F7',
      boxShadow: 'none',
      border: '1px solid transparent',
      borderRadius: '3px',
      padding: '10px 12px',
      fontSize: '13px',
      lineHeight: '15px',
    },
    '.Label': {
      fontFamily: '"Apercu Pro", "Helvetica", sans-serif',
      fontSize: '14px',
      fontWeight: '300',
      color: '#000000'
    },
    '.PickerItem': {
      fontFamily: '"Apercu Pro", "Helvetica", sans-serif',
      fontSize: '14px',
      fontWeight: '300',
      color: 'rgb(102, 102, 102)'
    },
  }
}